<template>
  <vs-tabs v-model="currentTabIndex">
    <vs-tab v-for="(tab, tabIndex) in tabList" :key="`field_tab_${tab}`" :label="tab" @click="moveFieldTab(tabIndex, tab)" />
    <vs-tab v-for="(tab, tabIndex) in renderAddTabList" :key="`tab_${tab.label}_${tabIndex}`" :label="tab.label" @click="moveTab(tabList.length + tabIndex, tab)" />
  </vs-tabs>
</template>

<script>
export default {
  props: {
    addTabList: { type: Array, default: () => [] },
  },

  data() {
    return {
      currentTabIndex: 0,
      tabList: ["전사", "본사", "인천공장", "당진공장", "포항공장", "중앙기술연구소"],
    };
  },

  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id, 10);
    },
    boardId() {
      return parseInt(this.$route.params.boardId, 10);
    },
    renderAddTabList() {
      return Array.isArray(this.addTabList) ? this.addTabList.slice(1) : [];
    },
  },

  created() {
    const routeName = this.$route.name;

    if (routeName === "excel-upload|tab") {
      const addIdx = this.renderAddTabList.findIndex((item) => item.pageType === "excel-upload");
      this.currentTabIndex = addIdx >= 0 ? this.tabList.length + addIdx : 0;
      return;
    }

    const { fd } = this.$route.query;
    if (!fd) {
      this.currentTabIndex = 0; // 전사
      return;
    }

    const index = this.tabList.indexOf(fd);
    this.currentTabIndex = index >= 0 ? index : 0;
  },

  watch: {
    "$route.query.fd"(field) {
      if (!field) {
        if (this.currentTabIndex !== 0) this.currentTabIndex = 0;
        return;
      }

      const index = this.tabList.indexOf(field);
      const nextIndex = index >= 0 ? index : 0;

      if (nextIndex !== this.currentTabIndex) this.currentTabIndex = nextIndex;
    },
  },

  methods: {
    moveFieldTab(tabIndex, tab) {
      const query = { ...this.$route.query };

      if (tab === "전사") delete query.fd;
      else query.fd = tab;

      const target = {
        name: "list|tab",
        params: { boardId: this.boardId, pageType: "list" },
        query,
      };

      // 같은 경로면 push 막기
      const resolved = this.$router.resolve(target).route.fullPath;
      if (resolved === this.$route.fullPath) return;

      this.$router.push(target);
    },

    moveTab(tabIndex, tab) {
      this.$emit("moveTab", tabIndex, tab);
    },
  },
};
</script>
